import React, { Component } from 'react';
import { toElement } from '../../utils/scroll';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from '../../store/actions';
import { Icon, Button } from 'antd';
import LanguageDropDown from '../Language/LanguageDropDown';
import { messages } from './Translate';
import md5 from 'md5';
import { screenSizes } from '../../constant/ScreenSizes';
import { loadSelectedFlag, loadSelectedLang, getLocale } from '../../utils/locale';
import { withRouter } from 'react-router-dom';
import './TopBar.css';
import { postLogin } from '../../services/authentication';
import { getParentAffiliateProfile } from '../../services/affiliate';
import { alertError } from '../../utils/alert';
import { setLocalStorage_login, setLocalStorage_firstLogin, removeLocalStorage } from '../../utils/localStorage';
import { errorMessages } from '../../constant/ErrorCodeTranslation';
import { getImage, openLiveChat } from '../../utils/common';
import queryString from 'query-string';
import { isMarketClosingDate, getCountryCodeByCurrency } from '../../utils/formatter';
import { sendOTP } from '../../services/oneTimePin';
import { otpModule } from '../../constant/otpModule';
import { performLogout } from '../../utils/common';
import { deleteCache } from '../../utils/common';




class TopBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTopBar: false,
            showLanguageDropDown: false,
            selectedLocaleFlag: '',
            selectedLocaleLang: '',
            regModel: {
                fullName: '',
                userName: '',
                mobilenumber: '',
                emailaddress: ''
            }
        }
    }

  
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleSelectedLocale();
        const parsed = queryString.parse(window.location.search);

        if (parsed.RegistrationPopUp === '1') {
            getParentAffiliateProfile(parsed.parentAffiliateCode)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.result != null && response.data.result.currency === 'IDR') {
                            this.props.openPopUp('PopUpIDRMarketClosure');
                        }
                        else {
                            this.props.openPopUp('Registration');
                        }
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.props.toggleLoading(false);
                });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleClickEnter = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            this.handleLogin();
        }
    }

    handleScroll = () => {
        this.setState({
            activeTopBar: !(window.scrollY === 0)
        })
    }

    handleSelectedLocale = () => {
        this.setState({
            selectedLocaleFlag: loadSelectedFlag(),
            selectedLocaleLang: loadSelectedLang()
        })
    }

    toggleHeaderLanguage = () => {
        let mobileTabletScreenSize = screenSizes.slice(0, 3); // xs, sm, md
        if (mobileTabletScreenSize.includes(this.props.screenSize)) {
            this.props.openLanguagePopUp();
        } else {
            this.setState({
                showLanguageDropDown: !this.state.showLanguageDropDown
            })
        }
    }

    scrollToElement = (element) => {
        toElement(document.querySelector(element));
    }

    toggleRegistration = () => {
        var countryCode = getLocale().split('-')[1];

        if (countryCode === 'id') {
            this.props.openPopUp('PopUpIDRMarketClosure')
        }
        else {
            this.props.openPopUp('Registration')
        }
    }

    toggleForgotPasswordPopUp = () => {
        this.props.openPopUp('ForgotPassword')
    }

    translateErrorCode = (key) => {
        return errorMessages[key] ? this.props.intl.formatMessage(errorMessages[key]) : key;
    }


    handleLogin = () => {
        const username = document.querySelector('#username').value;
        const password = document.querySelector('#password').value;

        if (this.props.screenwidth < 1751) {
            this.props.openPopUp('Login')
        }
        else {
            if (!username || !password) {
                return alertError(this.props.intl.formatMessage(errorMessages.Error), this.props.intl.formatMessage(errorMessages.AFF00023));
            }
            this.props.toggleLoading(true);
            postLogin(username, md5(password))
                .then(response => {
                    try {
                        if (response.status === 200) {
                            if (response.data.errorCode) {
                                if (response.data.errorCode !== 'AFF00029') {
                                    if (errorMessages[response.data.errorCode]) {
                                        alertError(this.props.intl.formatMessage(errorMessages.Error), this.props.intl.formatMessage(errorMessages[response.data.errorCode]));
                                        return;
                                    }
                                }
                            }

                            let affProfile = response;
                            let phone, userName, email = '', affCode;
                            deleteCache();

                            if (response.data.errorCode === 'AFF00029') {
                                phone = response.data.result.accessToken.affProfile.contactPrefix + response.data.result.accessToken.affProfile.telephone;
                                userName = response.data.result.accessToken.affProfile.userName;
                                email = response.data.result.accessToken.affProfile.email;
                                affCode = response.data.result.accessToken.affProfile.affiliateCode;
                            } else {
                                phone = affProfile.data.accessToken.affProfile.contactPrefix + affProfile.data.accessToken.affProfile.telephone;
                                userName = affProfile.data.accessToken.affProfile.userName;
                                email = affProfile.data.accessToken.affProfile.email;
                                affCode = affProfile.data.accessToken.affProfile.affiliateCode;
                            }

                            sendOTP(otpModule.AffiliateLogin, {
                                verificationType: 'Phone',
                                loginModel: {
                                    userName: username,
                                    affiliateCode: affCode
                                }
                            }).then(response2 => {
                                if (!response2.data.errorCode || ['AFF25014', 'AFF25015'].includes(response2.data.errorCode)) {  //success

                                    if (response2.data.result.isOTPActive) {
                                        this.props.openPopUp('OTPLogin',
                                            {
                                                module: otpModule.AffiliateLogin,
                                                successCallBack: () => this.login(affProfile),
                                                verificationType: response2.data.result.verificationType,
                                                disableSwitchMethod: response2.data.errorCode ? true : false,
                                                popupCallback: response2.data.errorCode ? () => {
                                                    alertError(this.translateErrorCode('Error'), this.translateErrorCode(response2.data.errorCode));
                                                } : null,
                                                phone: phone,
                                                userName: userName,
                                                email: email,
                                                affiliateCode: affCode
                                            }
                                        );
                                    } else {
                                        this.login(affProfile);
                                    }
                                } else { //error
                                    alertError(this.translateErrorCode('Error'), this.translateErrorCode(response.data.errorCode));
                                }
                            }).finally(() => {
                                this.props.toggleLoading(false);
                            });
                        }
                    } catch (error) {
                        performLogout();
                        console.error(error);
                    }
                })
                .catch(error => {
                    performLogout();
                    console.error(error);
                })
                .finally(() => {
                    this.props.toggleLoading(false);
                });
        }
    };
                
    login = (response) => {
        if (response.data.errorCode) {
            if (response.data.errorCode === 'AFF00029') {
                this.props.openPopUp('EnforceChangePassword', {
                    isForceReset: true,
                    userName: response.data.result.accessToken.affProfile.userName,
                    email: response.data.result.accessToken.affProfile.email
                });
            }
        }
        else {
            // Remove Cache after login
            deleteCache();

            if (response.data.accessToken.affProfile.isFirstLogin) {
                setLocalStorage_firstLogin(response.data, getCountryCodeByCurrency(response.data.accessToken.affProfile.currency));
            }
            else {
                setLocalStorage_login(response.data, getCountryCodeByCurrency(response.data.accessToken.affProfile.currency));
            }

            this.props.closePopUp();
            if (response.data.accessToken.affProfile.currency === "IDR" && isMarketClosingDate()) {
                removeLocalStorage();
                //Pop Up Notification
                this.props.openPopUp('PopUpIDRMarketClosure_16March');
            }
            else {
                //redirect to lmr
                window.location.href = process.env.REACT_APP_SUB_FOLDER
            }
        }
    }

    logoLanguage = (lang) => {
        return getImage('Fun88_Affiliate_logo_' + lang.split('-')[1].toUpperCase() + '.webp');
    }

    render() {
        const { activeTopBar, showLanguageDropDown, selectedLocaleFlag, selectedLocaleLang } = this.state;
        const { toggleRegistration, toggleForgotPasswordPopUp } = this;
        const { formatMessage } = this.props.intl;
        return (
            <React.Fragment >
                <header className={`home-header ${activeTopBar ? "active" : "top"}`}>
                    <div className="header-container">
                        <div>
                            <div>
                                <img src={this.logoLanguage(getLocale())} className="logo-image" alt="logo"
                                    height="70px" max-height="70px" width="auto"
                                    style={{ cursor: 'pointer' }} onClick={() => this.scrollToElement(".section-one")} />
                            </div>
                        </div>
                        <div>
                            <div className="header-navi-container">
                                <div><span className="header-navi-title" onClick={() => this.scrollToElement(".section-two")}>{formatMessage(messages.WhyJoin)}</span></div>
                                <div><span className="header-navi-seperator" /></div>
                                <div><span className="header-navi-title" onClick={() => this.scrollToElement(".section-three")}>{formatMessage(messages.HowToJoin)}</span></div>
                                <div><span className="header-navi-seperator" /></div>
                                <div><span className="header-navi-title" onClick={() => this.scrollToElement(".section-four")}>{formatMessage(messages.AboutUs)}</span></div>
                                <div><span className="header-navi-seperator" /></div>
                                <div><span className="header-navi-title" onClick={() => this.scrollToElement(".section-five")}>{formatMessage(messages.Commission)}</span></div>
                                {
                                    this.props.intl.locale.split('-')[1] === 'cn' &&
                                    <>
                                        <div><span className="header-navi-seperator" /></div>
                                        <div><span className="header-navi-title" onClick={() => this.props.openPopUp('ContactUs')}>{formatMessage(messages.ContactUs)}</span></div>
                                    </>
                                }
                            </div>
                        </div>
                        <div className="header-login-control">
                            {['cn', 'th', 'vn'].includes(this.props.intl.locale.split('-')[1]) &&
                                <Button className="homepage-topbar-button livechat" onClick={openLiveChat}>
                                    <label className="homepage-topbar-livechat-text">{formatMessage(messages.lblLiveChat)}</label>
                                    <Icon style={{ marginRight: '3%' }} type="customer-service" /></Button>}
                            <div className="header-langauge-desktop" onClick={this.toggleHeaderLanguage}>
                                <img className="current-display-flag" src={getImage(`${selectedLocaleFlag}.png`)} alt="flag" />
                            </div>
                            <div className="header-language-mobile">
                                <div className="header-label">
                                    <p className="header-input-title">{formatMessage(messages.ChangeLanguage)}</p>
                                </div>
                                <div className="header-flag" onClick={this.toggleHeaderLanguage}>
                                    <span className="display-language current-display-language">{selectedLocaleLang}</span>
                                    <img className="current-display-flag" src={getImage(`${selectedLocaleFlag}.png`)} alt="flag" />
                                    <span className="language-arrow">
                                        <Icon type="down" />
                                    </span>
                                </div>
                                <div className={`header-language-selection ${showLanguageDropDown && "open"}`}>
                                    <LanguageDropDown />
                                </div>
                            </div>
                            <div className="homepage-topbar-buttons">
                                <div className="homepage-topbar-button login" onClick={this.handleLogin} >{formatMessage(messages.Login)}</div>
                                <div className="homepage-topbar-button join" onClick={toggleRegistration}>{formatMessage(messages.JoinNow)}</div>
                            </div>
                            <div className="header-input-password">
                                <p className="header-input-title">{formatMessage(messages.Password)}</p>
                                <input className="header-input" type="password" name="password" id="password" defaultValue="" tabIndex="2" onKeyUp={this.handleClickEnter} />
                                <div className="remember-password-control">
                                    <p style={{ textDecoration: "underline", direction: "ltr", cursor: "pointer" }} onClick={toggleForgotPasswordPopUp}>{formatMessage(messages.ForgotPassword)}</p>
                                </div>
                            </div>
                            <div className="header-input-username">
                                <p className="header-input-title">{formatMessage(messages.Username)}</p>
                                <input className="header-input" type="text" name="name" id="username" defaultValue="" tabIndex="1" onKeyUp={this.handleClickEnter} />
                            </div>
                        </div>
                    </div>
                    
          

           
                </header>
                
            </React.Fragment >
        );
    }
};




const mapStateToProps = state => {
    return {
        screenSize: state.responsiveui.screensize,
        screenwidth: state.responsiveui.screenwidth
    };
};

const mapDispatchToProps = dispatch => {
    return {
        openPopUp: (type, param) => dispatch(actions.openPopUp(type, param)),
        closePopUp: () => dispatch(actions.closePopUp()),
        openLanguagePopUp: () => dispatch(actions.openLanguagePopUp()),
        toggleLoading: (isShow) => dispatch(actions.toggleLoading(isShow))
    };
};

export default withRouter(
    injectIntl(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(TopBar)
    )
);